export enum BonusWageringOrderType {
  ANY_ORDER = 'Any Order',
  RM_FIRST = 'RM First',
}
